export default __webpack_public_path__ + "static/media/resume.5770d6b7.pdf";